import React from 'react'

import type { CollapsibleContextProps } from './CollapsibleContext'
import { CollapsibleContext } from './CollapsibleContext'

export const CollapsibleProvider = ({
  children,
  defaultIsExpanded,
  onToggleExpand,
  isExpanded: controlledIsExpanded,
}: {
  children: React.ReactNode
} & Pick<
  CollapsibleContextProps,
  'defaultIsExpanded' | 'isExpanded' | 'onToggleExpand'
>) => {
  const [localIsExpanded, setIsExpanded] = React.useState(
    defaultIsExpanded || false
  )
  const isExpanded =
    controlledIsExpanded != null ? controlledIsExpanded : localIsExpanded

  return (
    <CollapsibleContext.Provider
      value={{
        onExpand: () => setIsExpanded(true),
        onCollapse: () => setIsExpanded(false),
        onToggleExpand: () => {
          onToggleExpand?.()
          setIsExpanded(!isExpanded)
        },
        isExpanded,
        defaultIsExpanded: controlledIsExpanded ?? Boolean(defaultIsExpanded),
      }}
    >
      {children}
    </CollapsibleContext.Provider>
  )
}
